export default __webpack_public_path__ + "static/media/project-status-pending-commission.947ef891.svg";